<template>
    <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
        <!-- Alert message -->
        <div>
          <v-alert :type="alert_type" :value="alert" :model-value="alert" transition="scale-transition">{{alert_message}}</v-alert>
        </div>
        <!-- Header-->
        <header-component :headerTitle="headerText" />
         <v-snackbar
          v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
          <v-layout align-center pr-4>
            <v-icon class="pr-3 ml-2" dark large>{{ snackbar.icon }}</v-icon>
            <v-layout column>
              <div>{{ snackbar.text }}</div>
            </v-layout>
          </v-layout>
          <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-snackbar>
        <v-row justify="center">
         <v-dialog v-model="change_disposition_popup" persistent max-width="364px">
             <v-card class="v-card-100">
             <v-card class="v-card-100 custom-shadow ma-0">
                <v-card-title class="pa-0">              
                    <v-row class="ma-1">
                      <span class="font-weight-bold pl-2 pr-2">Set Disposition</span>
                      <v-spacer></v-spacer>
                        <v-icon @click="change_disposition_popup = false">mdi-close</v-icon>
                    </v-row>              
                </v-card-title>
              </v-card>
                <v-card-text class="download-email mt-3">
                      <v-row>
                         <v-col cols="12" sm="12" md="12">
                            <v-autocomplete 
                              v-model="disposition_val" 
                              :items="disposition_items" 
                              item-title="original_code" 
                              item-value="id" 
                              label="Select Disposition" 
                              variant="outlined" 
                              hide-details
                              >  
                              <template #item="{ props, item }">
                              <v-list-item
                                v-bind="props"
                                :disabled="item.raw.disabled"
                              />
                            </template></v-autocomplete>
                         </v-col>
                      </v-row>
                      <v-row>
                         <v-col cols="12" sm="12" md="12">
                            <v-text-field v-model="remarks" label="Enter Remarks" variant="outlined"></v-text-field>
                         </v-col>
                      </v-row>
                </v-card-text>
                <v-card-actions center>
                <v-spacer></v-spacer>
                <v-btn small class="text-none" variant="outlined" large color="primary" @click="change_disposition_popup = false">Cancel</v-btn>
                <v-btn small class="text-none" variant="flat"  large color="primary" @click="updateDispotion" :disabled="!disposition_val || !remarks || number > 0">Confirm</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
             </v-card>
         </v-dialog>
        </v-row>
         <!-- seacrh, action button and filter -->
        <v-card-title class="action-style mt-6">
         <!-- Search fields -->
          <v-row class="ma-3 mb-0">
            <v-autocomplete v-model="select_field" :items="select_field_items" label="Select Field" variant="outlined" style="max-width: 158px;" class="mr-4"> </v-autocomplete>
            <v-text-field  prepend-inner-icon="mdi-magnify" v-model="search_tag" v-no-edge-space label="Search" style="max-width: 270px;" variant="outlined" v-on:keyup.enter="loadData" :disabled="!select_field"></v-text-field>
              <v-spacer></v-spacer>
            <v-card-actions style="margin-top: -30px;">
              <v-btn class="mr-2 custum-button" variant="flat"  :disabled="selected.length === 0" color="primary" @click="openDispositionDialog" size="x-large" style="min-height:55px; min-width:130px; font-weight:600;">Set Disposition</v-btn>
            </v-card-actions>
          </v-row>
        </v-card-title>
        <!-- tabs data -->
        <v-layout column>
          <v-flex md6 style="overflow: auto">
            <v-data-table
              density="compact"
              :dense="true"
              :search="search"
              v-model="selected"
              show-select
              disable-pagination
              :hide-default-footer="true"
              :headers="headers"
              :items="table_data"
              :loading="loading"
              fixed-header
              height="100%"
              return-object
              :items-per-page="pageSize"
              loading-text="Loading Data... Please wait" class="elevation-1">
              <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
              <span v-if="header.key !== 'images' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else>-</span>
            </template>
                <!-- <template v-for="(header, index) in headers" v-slot:[`item.${header.value}`]="{ item }">
                    <span v-if="item[header.value] !== null && item[header.value] !== ''">
                      <GlobalTooltip :text="item[header.value]" />
                    </span>
                    <span v-else>
                      <span>-</span>
                    </span>
              </template> -->
              <template #bottom></template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
    </v-card>
    </template>
    <script>
    import HeaderComponent from '../../../../commoncomponents/HeaderComponent.vue';
    import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
    export default {
        components : {
            HeaderComponent
        },
        data(){
            return {
                headerText: "Change Disposition",
                alert : false,
                alert_type : "success",
                alert_message : '',
                search_tag: null,
                loading : false,
                selected:[],
                headers : [
                    { title: "Tag ID", key: "tag_number" },
                    { title: "Article ID", key: "article_id"},
                    { title: "Article Description", key: "article_description" },
                    { title: "Brand", key: "brand" },
                    { title: "Location", key: "location" },
                    { title: "S No. 1", key: "serial_number_1" },
                    { title: "S No. 2", key: "serial_number_2"},
                    { title: "Stage", key: "stage" },
                    { title: "Sub-Disposition", key: "sub_disposition" },
                    { title: "Sub-Location", key: "sub_location" }
                    ],
                table_data : [],
                snackbar: false,
                select_field:null,
                select_field_items:["Tag ID", "Serial Number 1", "Serial Number 2"],
                snackbar: {
                    color: null,
                    icon: null,
                    mode: null,
                    position: "top",
                    text: null,
                    timeout: 7500,
                    title: null,
                    visible: false
                    },
                number: 0,
                page: 1,
                totalPages: 1,
                totalCount: '',
                pageSize: defaultPageSize,
                pageSizes: defaultPageSizes,
                disposition_data:[],
                change_disposition_popup: false,
                disposition_val:null,
                disposition_items:[],
                organization_name:'',
                remarks:''
            }
        },
        async created(){
           this.organization_name = this.$store.state.organization_name
           if(this.$isRelianceClient()){
            this.select_field_items = ["Tag ID", "Box Serial Number", "Product Serial Number"]
           }
            this.getDispositionData();
        },
        methods: {
            showAlert(alert_type, alert_message) {
            this.alert = true;
            this.alert_type = alert_type;
            this.alert_message = alert_message;
            this.scrollToTop();
            this.alertTimeOut();
          },
          alertTimeOut() {
            setTimeout(() => {
                this.alert = false;
            }, 3000);
          },
          scrollToTop() {
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          },
          loadData(){
            this.loading = true;
            this.selected = []
            this.table_data = []
            this.page = 1
            this.totalPages = 1
             this.headers = [
              { title: "Tag ID", key: "tag_number" },
              { title: "Article ID", key: "article_id"},
              { title: "Article Description", key: "article_description" },
              { title: "Brand", key: "brand" },
              { title: "Location", key: "location" },
              { title: "S No. 1", key: "serial_number_1" },
              { title: "S No. 2", key: "serial_number_2"},
              { title: "Stage", key: "stage" },
              { title: "Sub-Disposition", key: "sub_disposition" },
              { title: "Sub-Location", key: "sub_location" }
            ];
            this.getData();       
          },
          getData() {
            const params ={
              page: this.page,
              per_page: this.pageSize,
            }
            if(this.select_field === 'Tag ID') {
                params.search = this.search_tag,
                params.search_in = 'tag_number'
              }else if(this.select_field === 'Serial Number 1' || this.select_field === 'Box Serial Number'){
               params.search = this.search_tag,
                params.search_in = 'serial_number1'
              }else if(this.select_field === 'Serial Number 2' || this.select_field === 'Product Serial Number'){
               params.search = this.search_tag,
                params.search_in = 'serial_number2'
              }
            this.$httpSecured
              .get('/api/v1/warehouse/inventories/search_inventory_items',{params : params})
              .then(response => {
                if (response.data) {
                  this.table_data = response.data.inventories;
                  this.totalPages = response.data.meta.total_pages;
                  this.totalCount = response.data.meta.total_count;                                
                  this.loading = false;
                } else {
                  this.loading = false;
                  this.showAlert("error", "No Data Found");
                }
              })
              .catch(error => {
                this.showAlert("error", error.response.data.error);
                this.loading = false;
              });
          },
          getDispositionData() {
            this.$httpSecured
            .get('/api/v1/warehouse/inventories/inventory_dispositions')
              .then(response => {
                if (response.data) {
                  this.disposition_items = response.data.dispositions;             
                  this.loading = false;
                } else {
                  this.loading = false;
                  this.showAlert("error", "No Data Found");
                }
              })
              .catch(error => {
                this.showAlert("error", error.response.data.error);
                this.loading = false;
              });
          },
          handlePageSizeChange(size){
            this.pageSize = size;
            this.page = 1
            this.getData()
          },
          handlePageChange(value) {
            this.page = value;
            this.getData()
          },
          openDispositionDialog(){
            this.change_disposition_popup = true;
            this.disposition_val = null;
            const selected_dis = this.selected.map(item => item.stage);
            this.disposition_items = [...this.disposition_items.map(item => ({
              ...item,
              disabled: selected_dis.includes(item.original_code)
            }))];
          },
          updateDispotion(){
            this.number++;
            this.$httpSecured
              .post('/api/v1/warehouse/inventories/update_disposition',
              {
               "id":this.selected.map(item => item.id),
               "disposition_id":this.disposition_val,
               "remarks": this.remarks
              })  
              .then(response => {
                if (response.data) {
                   this.change_disposition_popup = false;
                   this.disposition_val = '';
                   this.snackbar = true;               
                   this.email_id='';
                   this.snackbar = {
                        color: "success",
                        icon: "mdi-check-circle",
                        mode: "multi-line",
                        position: "top",
                        timeout: 3000,
                        title: 'Success',
                        text: response.data.message ? response.data.message : response.data,
                        visible: true
                      };          
                  this.loading = false;
                  this.select_field = null;
                  this.search_tag = '';
                  this.table_data = []; 
                  this.number = 0;
                } else {
                  this.number = 0;
                  this.loading = false;
                  this.showAlert("error", "No Data Found");
                }
              })
              .catch(error => {
                this.number = 0;
                this.showAlert("error", error.response.data.error ? error.response.data.error : error.response.data);
                this.loading = false;
              });
          }
        }
    }
    </script>
    <style scoped>    
      .item-selected{
        margin-top: 23px;
        position: absolute;
        left: 41%;
      }
      @media (max-height: 1104px) {
        .PaddingItemPerPage{
          padding: 8px !important;
        }
      }
      @media (min-height: 1126px) {
        .PaddingItemPerPage{
          padding: 24px !important;
        }
    }
    .v-data-table {
       height: calc(var(--vh, 1vh) * 100 - 262px) !important;
      }
    </style>